export const PARKS_AND_GARDENS = "PARKS_AND_GARDENS";
export const GREENING_PROJECT = "GREENING_PROJECT";
export const POLLUTION = "POLLUTION";
export const SOLIDWASTE_PROJECT = "SOLIDWASTE_PROJECT";
export const LIQUIDWASTE_PROJECT = "LIQUIDWASTE_PROJECT";
export const SET_ENVIRONMENT_AND_SANITATION = "SET_ENVIRONMENT_AND_SANITATIONT"